export class UpdateDashboard {
	static readonly type = '[Dashboard] Update dashboard data';
	constructor(public nodeId: string) {}
}

export class UpdateWidgetData {
	static readonly type = '[Dashboard] Update widget data';
}

export class UpdateNodeData {
	static readonly type = '[Dashboard] Update node data';
	constructor(public type: string, public data: any) {}
}

export class UpdateActiveWidget {
	static readonly type = '[Dashboard] Update active widget';
	constructor(public activeWidget: number) {}
}

export class UpdateDetailedData {
	static readonly type = '[Dashboard] Update detailed data';
}

export class UpdateDateFilter {
	static readonly type = '[Dashboard] Update date filter';
	constructor(public startDate: string, public endDate: string, public selectedRange: number) {}
}

export class ResetDashboardData {
	static readonly type = '[Dashboard] Reset dashboard data';
}

export class UpdateSmartCleaningData {
	static readonly type = '[Dashboard] Update smart cleaning data';
	constructor(public officeId: string, public date: string) {}
}
